import axios from 'axios';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API_URL = `${BACKEND_URL}/api/company/export/`;

const exportOrder = async (formData) => {
  const {month} = formData

  const response = await axios.post(`${API_URL}order`, formData, {
      responseType: 'blob',  // Set the response type to blob for binary data
  });

  if (response.status === 200) {
      // Create a new Blob object from the response data
      const url = window.URL.createObjectURL(new Blob([response.data]));

      // Create a link to trigger the download
      const link = document.createElement('a');
      link.href = url;
      link.setAttribute('download', `รายงานขาย ${month}.xlsx`);  // Set the downloaded file name
      document.body.appendChild(link);

      // Programmatically click the link to trigger the download
      link.click();

      // Remove the link after downloading
      link.remove();
  } else {
      console.error('Failed to export Excel file.');
  }

  const zipResponse = await axios.post(`${API_URL}orderabb`, formData, {
    responseType: 'blob',
  });

  if (zipResponse.status === 200) {
    const zipUrl = window.URL.createObjectURL(new Blob([zipResponse.data]));
    const zipLink = document.createElement('a');
    zipLink.href = zipUrl;
    zipLink.setAttribute('download', `ใบกำกับภาษีอย่างย่อ ${month}.zip`);
    document.body.appendChild(zipLink);
    zipLink.click();
    zipLink.remove();
  } else {
      console.error('Failed to export zip file.');
  }
};

const exportStockIn = async (formData) => {
  const {month} = formData

  const response = await axios.post(`${API_URL}stockin`, formData, {
      responseType: 'blob',  // Set the response type to blob for binary data
  });

  if (response.status === 200) {
      // Create a new Blob object from the response data
      const url = window.URL.createObjectURL(new Blob([response.data]));

      // Create a link to trigger the download
      const link = document.createElement('a');
      link.href = url;
      link.setAttribute('download', `รายงานซื้อ ${month}.xlsx`);  // Set the downloaded file name
      document.body.appendChild(link);

      link.click();
      link.remove();
  } else {
      console.error('Failed to export Excel file.');
  }
};

const exportStockBalance = async (formData) => {
  const { asOfDate } = formData;
  const response = await axios.post(`${API_URL}stockbalance`, formData, {
    responseType: 'blob'
  });
  
  const url = window.URL.createObjectURL(new Blob([response.data]));
  const link = document.createElement('a');
  link.href = url;
  link.setAttribute('download', `stock_balance_${asOfDate}.xlsx`);
  document.body.appendChild(link);
  link.click();
  link.remove();
};

// New function for downloading invoice
const exportInvoice = async (month, year) => {
  try {
    const response = await axios.post(`${BACKEND_URL}/api/company/invoices/monthly/zip`, {
      month: month,
      year: year
    }, {
      responseType: 'blob'
    });

    if (response.status === 200) {
      // Create a new Blob object from the response data
      const url = window.URL.createObjectURL(new Blob([response.data]));

      // Create a link to trigger the download
      const link = document.createElement('a');
      link.href = url;
      link.setAttribute('download', `Invoices_${year}_${month.toString().padStart(2, '0')}.zip`);  // Set the downloaded file name
      document.body.appendChild(link);
      link.click();
      link.remove();
    } else {
      console.error('Failed to download monthly invoices ZIP file.');
    }
  } catch (error) {
    console.error('Error downloading monthly invoices ZIP:', error);
    throw error;
  }
};

const exportAbb = async (companyOrderId) => {
  try {
    const response = await axios.get(`${BACKEND_URL}/api/company/abb/${companyOrderId}`, {
      responseType: 'blob'
    });

    if (response.status === 200) {
      // Create a new Blob object from the response data
      const url = window.URL.createObjectURL(new Blob([response.data]));

      // Create a link to trigger the download
      const link = document.createElement('a');
      link.href = url;
      link.setAttribute('download', `ABB_${companyOrderId}.xlsx`);  // Set the downloaded file name
      document.body.appendChild(link);

      // Programmatically click the link to trigger the download
      link.click();

      // Remove the link after downloading
      link.remove();
    } else {
      console.error('Failed to download invoice file.');
    }
  } catch (error) {
    console.error('Error downloading invoice:', error);
    throw error;
  }
};

const exportMonthlyReports = async (month, year, exportType = 'combined') => {
  try {
    const response = await axios.post(
      `${BACKEND_URL}/api/company/export/monthly-reports`, 
      {
        month: month,
        year: year,
        exportType: exportType  // 'combined', 'invoices', or 'salesSummary'
      }, 
      {
        responseType: 'blob'
      }
    );

    if (response.status === 200) {
      // Extract filename from Content-Disposition header
      const contentDisposition = response.headers['content-disposition'];
      let filename = 'Monthly_Reports.zip'; // Default filename
      
      if (contentDisposition) {
        const filenameMatch = contentDisposition.match(/filename="?(.+)"?/i);
        if (filenameMatch && filenameMatch[1]) {
          filename = filenameMatch[1].replace(/"/g, ''); // Remove quotes if any
        }
      }

      // Create a new Blob object from the response data
      const url = window.URL.createObjectURL(new Blob([response.data]));

      // Create a link to trigger the download
      const link = document.createElement('a');
      link.href = url;
      link.setAttribute('download', filename);  // Use the actual filename from backend
      document.body.appendChild(link);

      // Programmatically click the link to trigger the download
      link.click();

      // Remove the link and revoke the object URL to free memory
      link.remove();
      window.URL.revokeObjectURL(url);

      return { success: true, filename };
    } else {
      console.error('Failed to download file.');
      return { success: false, error: 'Download failed' };
    }
  } catch (error) {
    console.error('Error downloading monthly reports:', error);
    throw error;
  }
};

const exportMonthlyTaxInvoices = async (month, year) => {
  try {
    const response = await axios.post(
      `${BACKEND_URL}/api/company/export/monthly-tax-invoices`,
      { month, year },
      { responseType: 'blob' }
    );

    if (response.status === 200) {
      const contentType = response.headers['content-type'] || '';

      // Backend returns JSON when there is no data for the selected month.
      // In that case, do not save it as a file.
      if (contentType.includes('application/json')) {
        const text = await response.data.text();
        let payload = {};
        try {
          payload = JSON.parse(text);
        } catch {
          payload = { message: 'No tax invoices found for this month' };
        }
        return {
          success: false,
          noData: true,
          message: payload.message || 'No tax invoices found for this month',
        };
      }

      const contentDisposition = response.headers['content-disposition'];
      let filename = `TaxInvoices_${year}_${String(month).padStart(2, '0')}.zip`;

      if (contentDisposition) {
        const filenameMatch = contentDisposition.match(/filename="?(.+)"?/i);
        if (filenameMatch && filenameMatch[1]) {
          filename = filenameMatch[1].replace(/"/g, '');
        }
      }

      const url = window.URL.createObjectURL(new Blob([response.data]));
      const link = document.createElement('a');
      link.href = url;
      link.setAttribute('download', filename);
      document.body.appendChild(link);
      link.click();
      link.remove();
      window.URL.revokeObjectURL(url);
      return { success: true, filename };
    }

    return { success: false, error: 'Download failed' };
  } catch (error) {
    throw error;
  }
};

const getCreditNoteEligibleOrders = async (month, year) => {
  try {
    const response = await axios.get(`${BACKEND_URL}/api/company/export/credit-note-eligible`, {
      params: { month, year },
    });
    return response.data;
  } catch (error) {
    throw error;
  }
};

const assignCreditNoteDates = async (month, year, refundDates) => {
  try {
    const response = await axios.post(`${BACKEND_URL}/api/company/export/credit-note-assign`, {
      month, year, refundDates,
    });
    return response.data;
  } catch (error) {
    throw error;
  }
};

const exportMonthlyCreditNotes = async (month, year) => {
  try {
    const response = await axios.post(
      `${BACKEND_URL}/api/company/export/monthly-credit-notes`,
      { month, year },
      { responseType: 'blob' }
    );

    if (response.status === 200) {
      const contentType = response.headers['content-type'] || '';

      if (contentType.includes('application/json')) {
        const text = await response.data.text();
        let payload = {};
        try {
          payload = JSON.parse(text);
        } catch {
          payload = { message: 'No credit notes found for this month' };
        }
        return {
          success: false,
          noData: true,
          message: payload.message || 'No credit notes found for this month',
        };
      }

      const contentDisposition = response.headers['content-disposition'];
      let filename = `CreditNotes_${year}_${String(month).padStart(2, '0')}.zip`;

      if (contentDisposition) {
        const filenameMatch = contentDisposition.match(/filename="?(.+)"?/i);
        if (filenameMatch && filenameMatch[1]) {
          filename = filenameMatch[1].replace(/"/g, '');
        }
      }

      const url = window.URL.createObjectURL(new Blob([response.data]));
      const link = document.createElement('a');
      link.href = url;
      link.setAttribute('download', filename);
      document.body.appendChild(link);
      link.click();
      link.remove();
      window.URL.revokeObjectURL(url);
      return { success: true, filename };
    }

    return { success: false, error: 'Download failed' };
  } catch (error) {
    throw error;
  }
};

const getWhtSummary = async (month, year) => {
  try {
    const response = await axios.get(`${API_URL}wht-summary`, {
      params: { month, year },
    });
    return response.data;
  } catch (error) {
    throw error;
  }
};

const getMissingDataCustomers = async (month, year) => {
  try {
    const response = await axios.get(`${BACKEND_URL}/api/company/missing-data`, {
      params: { month, year }
    });
    return response.data;
  } catch (error) {
    throw error;
  }
};

export default {
    exportOrder,
    exportStockIn,
    exportStockBalance,
    exportInvoice,
    exportMonthlyReports,
    exportMonthlyTaxInvoices,
    exportAbb,
    getMissingDataCustomers,
    getCreditNoteEligibleOrders,
    assignCreditNoteDates,
    exportMonthlyCreditNotes,
    getWhtSummary,
};
